const TOWER_SUBSCRIBE_API = process.env.REACT_APP_TOWER_SUBSCRIBE_API;
const TOWER_HOME_API = process.env.REACT_APP_TOWER_HOME_API;
const TOWER_EVENTS_API = process.env.REACT_APP_TOWER_EVENTS_API;
const TOWER_PACKAGES_API = process.env.REACT_APP_TOWER_PACKAGES_API;
const TOWER_POLLS_API = process.env.REACT_APP_TOWER_POLLS_API;
const TOWER_API_USER = process.env.REACT_APP_API_USER;
const TOWER_API_DEPARTMENT = process.env.REACT_APP_API_DEPARTMENT;
const TOWER_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LANDING = "sports";

async function callApi(origin, endpoint, options = {}) {
  options.headers = {
    ...options.headers,
    "Content-Type": "application/json",
    Accept: "application/json",
    Cache: "no-cache",
  };

  const url = origin + endpoint;

  const response = await fetch(url, options);
  const data = await response.json();

  return data;
}

const api = {
  poll: {
    getIpClient() {
      return callApi("https://api.ipify.org/?format=json", "");
    },

    getResults() {
      return callApi(TOWER_POLLS_API, "");
    },
  },

  home: {
    getContent() {
      return callApi(TOWER_HOME_API, "");
    },
  },

  packages: {
    getAll() {
      return callApi(TOWER_PACKAGES_API, "");
    },
  },

  events: {
    getAll() {
      return callApi(TOWER_EVENTS_API, "");
    },
  },

  subscription: {
    create({ email, lang }) {
      console.log(TOWER_SUBSCRIBE_API)      
      return callApi(
        `${TOWER_SUBSCRIBE_API}`, '/subscriptions', {
          method: "POST",
          headers: {
            'Accept-Language': lang,
          },
          body: JSON.stringify({
            email: email,
            department: LANDING,
          })
        }
      );
    },
  },

  contact: {
    default({ name, email, subject, message, language }) {
        return callApi(`${TOWER_API_BASE_URL}`, '/contactus', {
            method: 'POST',
            headers: {
                'Accept-Language': language,
            },
            body: JSON.stringify({
                nameLastname: name,
                email,
                subject,
                comment: message,
                department: 'sports',
            }),
        })
    },
  },

  whatsapp: {
    get({ language }) {
      return callApi(
        `${TOWER_API_BASE_URL}/${TOWER_API_USER}`,
        `/whatsapp/${TOWER_API_DEPARTMENT}`,
        {
          method: "GET",
          headers: {
            "Accept-Language": language,
          },
        }
      );
    },
  },
};

export default api;
